<template>
  <div class="content">
    <div class="Tabs">

      <b-tabs card v-model="tabIndex">

        <b-tab :title="lang.tab_QuickView" :title-link-class="textColors" :title-item-class="textColors"
          :active="tabIndex == 0">

          <div v-if="selectedRows.length != 1">
            <p>{{lang.infotext_1}}</p>
          </div>

          <QuickViewTableComponent v-if="selectedRows.length == 1" :source="'false'" :lang="lang.QuickView">
          </QuickViewTableComponent>
          <LibraryFilesComponent v-if="selectedRows.length == 1 && !isHDLLibrary" :lang="lang.LibraryFiles">
          </LibraryFilesComponent>
          <LibraryFilesHDLComponent v-if="selectedRows.length == 1 && isHDLLibrary" :lang="lang.LibraryHDLFiles">
          </LibraryFilesHDLComponent>

        </b-tab>

        <b-tab :title="lang.tab_Tasks" :title-link-class="textColors"
          :title-item-class="textColors" :active="tabIndex == 1">
          <div v-if="selectedRows.length != 1">
            <p>{{lang.infotext_2}}</p>
          </div>
          
          <TasksComponent v-if="selectedRows.length == 1" :lang="lang.Tasks" parent="table"></TasksComponent>
        </b-tab>




        <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_WhereUse" :title-link-class="textColors"
          :title-item-class="textColors" :active="tabIndex == 2">
          <div v-if="selectedRows.length != 1">
            <p>{{lang.infotext_2}}</p>
          </div>
          <span v-if="appConf.status.isPRM">
            <WhereUseTableComponent :parent="'parts'" v-if="selectedRows.length == 1" :lang="lang.WhereUse">
            </WhereUseTableComponent>
            <br><br>
          </span>
          <WhereLibUsedComponent v-if="selectedRows.length == 1" :lang="lang.WhereLibUsed"></WhereLibUsedComponent>
          <br><br>

          <WhatIsIncludedComponent  parent="Table" v-if="selectedRows.length == 1 && selectedType" :lang="lang.WhatIsIncluded">
          </WhatIsIncludedComponent>
        </b-tab>
        <b-tab :title="lang.tab_Pins" :title-link-class="textColors" :title-item-class="textColors"
          :active="tabIndex == 3">
          <p v-if="!isPinsTable">{{ lang.infotext_4 }}</p>
          <PinsTableComponent v-if="isPinsTable" :lang="lang.PinsTable" parent="library"></PinsTableComponent>
        </b-tab>



      </b-tabs>

    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LibraryTypes from '@/constants/LibraryTypes'
import QuickViewTableComponent from '@/components/shared/QuickViewTableComponent'
import TasksComponent from '@/components/shared/TasksComponent'
import WhereUseTableComponent from '@/components/shared/WhereUseTableComponent'
import LibraryFilesComponent from '@/components/shared/LibraryFilesComponent'
import WhereLibUsedComponent from '@/components/shared/WhereLibUsedComponent'
import WhatIsIncludedComponent from '@/components/shared/WhatIsIncludedComponent'
import LibraryFilesHDLComponent from '@/components/shared/LibraryFilesHDLComponent'
import PinsTableComponent from '@/components/shared/PinsTableComponent'


export default {
  name: "Content",
  components: {
    QuickViewTableComponent,
    TasksComponent,
    WhereUseTableComponent,
    LibraryFilesComponent,
    WhereLibUsedComponent,
    WhatIsIncludedComponent,
    LibraryFilesHDLComponent,
    PinsTableComponent
  },
  props:{
    lang: Object,

  },
  data () {
    return {
      tabIndex: 0,

    }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',
      isPlugin: 'isPlugin',
      appConf: 'appConf',
      currentUser: 'currentUser'
    }),
    selectedType(){
      
      if (this.$store.getters.selectedRows.length != 0){
        
        if (this.$store.getters.selectedRows[0].col___libraryType == undefined){
          return false;
        }
        
        let elem = this.$store.getters.selectedRows[0].col___libraryType.value.display;
        return (elem == LibraryTypes.FOOTPRINT || elem == LibraryTypes.PADSTACK);
      }
      return false;
    },
    isHDLLibrary() {
      if (this.$store.getters.selectedRows.length != 0) {

        if (this.$store.getters.selectedRows[0].col___libraryType == undefined) {
          return false;
        }
        let elem = this.$store.getters.selectedRows[0].col___libraryType.value.display;
        return (elem == LibraryTypes.HDLSYMBOL);
      }
      return false;
    },
    isAssembly(){
      
      return false;

    },
    isAlternativeSelected(){
      return this.$store.getters.selectedAlternative.distributorPartId != undefined;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    libraryType() {
      if (this.$store.getters.selectedRows.length != 0) {
        
        if (this.$store.getters.selectedRows[0].col___libraryType != undefined) {
          return this.$store.getters.selectedRows[0].col___libraryType.value.display;
        }
        
      }
      return false;
    },
    isPinsTable() {
      let ret = false;
      switch (this.libraryType) {
        case LibraryTypes.PART:
          ret = true;
          break;
        // case LibraryTypes.SYMBOL:
        //   ret = true;
        //   break;
        case LibraryTypes.FOOTPRINT:
          ret = true;
          break;
        case LibraryTypes.HDLSYMBOL:
          ret = true;
          break;

        default:
                      
      }
      return ret; 
    }
  },
  created () {
    this.getTabIndex();
  },
  updated() {

  },

  watch: {
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__right"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################


      
    },

  },
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__right"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__right"];
      } else {
        this.tabIndex = 0;
      }

    },
  }
}
</script>

<style lang="scss">

  .Tabs{

    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryTable/Right/Content/Content.vue